import React, {Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {useSelector} from 'react-redux';
import ShieldLockOutlinedIcon from '@tenancy.nz/icons/ShieldLockOutlined';
import {Box, Text} from '@tenancy.nz/ui';
import Loader from '../../components/Loader';
import MessageFeature from '../message/MessageFeature';
import BannerContentLayout from '../../layouts/BannerContentLayout';
import FooterFeature from '../footer/footer-feature';
import Title from '../../ui/title';
import useRouteTitle from '../../hooks/use-route-title';
import banner from '../../assets/banner-portrait.jpg';

function TwoFactorEnrolLayoutFeature() {
  const message = useSelector(state => state.message);
  const title = useRouteTitle();

  const content = (
    <Box sx={{width: '100%', maxWidth: '450px', mx: 'auto'}}>
      {title && <Title text={title} />}
      {message.show && (
        <Box mb={5}>
          <MessageFeature />
        </Box>
      )}
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
      <Text
        variant="body2"
        color="#6E668F"
        weight="400"
        sx={{
          my: 6,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}>
        <ShieldLockOutlinedIcon color="#6E668F" />
        Password protected, secure login.
      </Text>
    </Box>
  );

  return (
    <BannerContentLayout
      disableBannerOnMobile
      content={content}
      footer={<FooterFeature />}
      imgSrc={banner}
    />
  );
}

export default TwoFactorEnrolLayoutFeature;
